module.exports = __webpack_public_path__ + "static/media/pen-click.7657c21e.wav";